import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield } from 'lucide-react';

const texts = {
  de: {
    title: 'Cookie-Einstellungen',
    text: 'Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Weitere Informationen finden Sie in unserer',
    link: 'Datenschutzerklärung',
    accept: 'ALLE AKZEPTIEREN',
    essential: 'NUR NOTWENDIGE',
  },
  it: {
    title: 'Impostazioni Cookie',
    text: 'Utilizziamo i cookie per offrirvi la migliore esperienza possibile sul nostro sito web. Per maggiori informazioni consultate la nostra',
    link: 'Informativa sulla Privacy',
    accept: 'ACCETTA TUTTI',
    essential: 'SOLO NECESSARI',
  }
};

export default function CookieBanner() {
  const { lang } = useLanguage();
  const t = texts[lang];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('enbi_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = (type) => {
    localStorage.setItem('enbi_cookie_consent', type);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-[90] p-4 md:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-enbi-navy border border-white/10 shadow-2xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6"
               style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' }}>
            <Shield className="text-enbi-gold flex-shrink-0 hidden md:block" size={28} strokeWidth={1.25} />
            <div className="flex-1">
              <h4 className="font-outfit text-white text-sm tracking-[0.15em] uppercase font-semibold mb-2">{t.title}</h4>
              <p className="text-white/50 text-sm leading-relaxed">
                {t.text}{' '}
                <Link to="/datenschutz" className="text-enbi-gold hover:text-enbi-gold-light underline transition-colors">
                  {t.link}
                </Link>.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0 w-full md:w-auto">
              <button
                onClick={() => handleAccept('essential')}
                data-testid="cookie-essential"
                className="border border-white/20 text-white/70 px-5 py-3 text-[11px] tracking-[0.15em] uppercase font-semibold hover:border-white/40 hover:text-white transition-all"
              >
                {t.essential}
              </button>
              <button
                onClick={() => handleAccept('all')}
                data-testid="cookie-accept"
                className="bg-enbi-gold text-enbi-navy px-5 py-3 text-[11px] tracking-[0.15em] uppercase font-bold hover:bg-enbi-gold-light transition-all"
              >
                {t.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
